import React, { useState } from "react";

// Lightweight native drag-and-drop Kanban.
// props: columns[], items[], getId, getStatus, columnTint{status:hex}, renderCard, onMove, onCardClick
export default function KanbanBoard({ columns, items, getId, getStatus, columnTint = {}, renderCard, onMove, onCardClick }) {
  const [dragId, setDragId] = useState(null);
  const [overCol, setOverCol] = useState(null);

  const byCol = (status) => items.filter((it) => getStatus(it) === status);

  return (
    <div className="flex gap-4 overflow-x-auto pb-4" data-testid="kanban-board">
      {columns.map((col) => {
        const tint = columnTint[col] || "#004030";
        const cards = byCol(col);
        return (
          <div
            key={col}
            data-testid={`kanban-col-${col}`}
            onDragOver={(e) => { e.preventDefault(); setOverCol(col); }}
            onDragLeave={() => setOverCol((c) => (c === col ? null : c))}
            onDrop={(e) => {
              e.preventDefault();
              if (dragId && onMove) onMove(dragId, col);
              setDragId(null); setOverCol(null);
            }}
            className={`flex-shrink-0 w-[270px] rounded-2xl border transition-colors ${overCol === col ? "border-[#004030] bg-[#f0f6f3]" : "border-slate-200 bg-slate-50/60"}`}
          >
            <div className="flex items-center justify-between px-3 py-3 border-b border-slate-200/70 sticky top-0">
              <div className="flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full" style={{ background: tint }} />
                <span className="font-display font-semibold text-sm text-[#1a231f]">{col}</span>
              </div>
              <span className="text-xs font-bold text-slate-500 bg-white border border-slate-200 rounded-full px-2 py-0.5">{cards.length}</span>
            </div>
            <div className="p-2.5 space-y-2.5 min-h-[120px] max-h-[65vh] overflow-y-auto">
              {cards.map((it) => (
                <div
                  key={getId(it)}
                  draggable={!!onMove}
                  onDragStart={() => onMove && setDragId(getId(it))}
                  onDragEnd={() => { setDragId(null); setOverCol(null); }}
                  onClick={() => onCardClick && onCardClick(it)}
                  data-testid={`kanban-card-${getId(it)}`}
                  className={`bg-white rounded-xl border border-slate-200 p-3 hover:shadow-md hover:border-[#004030]/40 transition-all ${onCardClick || onMove ? "cursor-pointer" : ""} ${dragId === getId(it) ? "opacity-40" : ""}`}
                  style={{ borderLeft: `3px solid ${tint}` }}
                >
                  {renderCard(it)}
                </div>
              ))}
              {cards.length === 0 && <p className="text-center text-xs text-slate-400 py-6">Drop here</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
